const rows = [
  { feature: "Processing Speed", us: "As fast as 24 hours", them: "10–13 weeks standard" },
  { feature: "Office Visit Required", us: "No — mail or drop-off", them: "Yes — in-person required" },
  { feature: "Photo Review", us: "Included — we verify compliance", them: "Self-service — rejections common" },
  { feature: "Application Review", us: "Expert review before submission", them: "No review — errors cause delays" },
  { feature: "Tracking", us: "Real-time status updates", them: "Limited status info" },
  { feature: "Customer Support", us: "Phone + email, 7 days/week", them: "Phone only, limited hours" },
  { feature: "Price Guarantee", us: "Best price guarantee", them: "No price matching" },
  { feature: "Acceptance Facility Help", us: "We find the shortest wait times", them: "Self-schedule at any facility" },
  { feature: "Refund Policy", us: "Satisfaction guarantee", them: "No refunds after submission" },
];

export default function FayettevilleARComparisonSection() {
  return (
    <section id="compare" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Compare</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Fast Passport Center vs. DIY Government Processing</h2>
        </div>
        <div className="mb-8 bg-amber-50 border border-[#F6C344]/40 rounded-lg p-6">
          <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">
            Fayetteville Passport Agency Appointment Not Available?
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Regional passport agency appointments are routinely booked 2–4 weeks out — and walk-ins are never accepted. If you searched for an appointment and came up empty, Fast Passport Center's registered courier channel is your fastest next step. No appointment. No waiting in line at the federal building. Processing as fast as 2–3 business days.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <div className="grid grid-cols-3 border-b border-gray-200 bg-[#EEF2F8]">
            <div className="p-4 font-bold text-[#1A365D] text-sm">Feature</div>
            <div className="p-4 font-bold text-[#1A365D] text-sm text-center">Fast Passport Center</div>
            <div className="p-4 font-bold text-gray-500 text-sm text-center">Government Standard</div>
          </div>
          {rows.map((row, i) => (
            <div key={i} className={`grid grid-cols-3 ${i !== rows.length - 1 ? "border-b border-gray-100" : ""}`}>
              <div className="p-4 text-sm text-gray-600 font-medium">{row.feature}</div>
              <div className="p-4 text-sm text-[#1A365D] font-semibold text-center bg-[#F7F8FA]/50">{row.us}</div>
              <div className="p-4 text-sm text-gray-500 text-center">{row.them}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}